import { Route } from 'components/dynamic-page/route-matchers/types';
import { HeadDataType } from 'components/head-data';
import { getTenantById } from 'tenants';
import { Themes as Tenants } from 'types/themes';

/**
 * Applies tenant-specific SEO rules to head tags
 * 
 * @param headTags The original head tags
 * @param routeName The current route name
 * @param tenant The current tenant
 * @returns Updated head tags with tenant-specific SEO settings
 */
export function applySeoRules(headTags: HeadDataType, routeName: Route, tenant: Tenants): HeadDataType {
  const tenantObj = getTenantById(tenant);
  
  // If tenant has no SEO config or no noFollowRoutes, return the original headTags
  if (!tenantObj?.config?.seo?.noFollowRoutes) {
    return headTags;
  }
  
  const { noFollowRoutes } = tenantObj.config.seo;
  
  // Apply noFollow rule for matching route
  if (noFollowRoutes.includes(routeName)) {
    return {
      ...headTags,
      noFollow: true,
    };
  }
  
  return headTags;
} 